import { createContext } from 'react';

interface IWindowSizeContext {
  windowWidth: number;
}

const WindowSizeContext = createContext({} as IWindowSizeContext);

export default WindowSizeContext;
